import { Box, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const UserWrapper = (): ReactElement => (
    <>
        <Box className="app-page-header">
            <Box
                className="header-menus"
                role="navigation"
                aria-labelledby="breadcrumb-title"
            >
                <Box className="flex-grow flex">
                    <Typography
                        className="title-header-menu"
                        component={NavLink}
                        to="details"
                        id="breadcrumb-title"
                    >
                        User Settings
                    </Typography>
                </Box>
                <NavLink
                    to="details"
                    className={({ isActive }) =>
                        isActive ? ' header-menu  active-menu' : 'header-menu '
                    }
                >
                    User details
                </NavLink>
                <NavLink
                    to="security"
                    className={({ isActive }) =>
                        isActive ? ' header-menu  active-menu' : 'header-menu '
                    }
                    hidden
                >
                    Security
                </NavLink>
            </Box>
        </Box>

        <Outlet />
    </>
);

export default UserWrapper;
